import React, { useEffect, useReducer, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { InitialStatePropType } from './propTypes';
import { reducer, actions } from './store';
import { getPortalEventManager, getPortalVariable } from './utils';

const CART_QUANTITY_UPDATE_EVENT = 'CART_QUANTITY_UPDATE_EVENT';

const HeaderContext = createContext();

export const useHeaderContext = () => useContext(HeaderContext);

export const HeaderProvider = ({ initialState, children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { platformBaseUrl, baseUrls } = state;

  useEffect(() => {
    const listener = () => actions.getBasketCount(platformBaseUrl)(dispatch);

    getPortalEventManager().then(eventManager => {
      eventManager.on(CART_QUANTITY_UPDATE_EVENT, listener);
    });

    return () => {
      getPortalEventManager().then(eventManager => {
        eventManager.off(CART_QUANTITY_UPDATE_EVENT, listener);
      });
    };
  }, []);

  const getBasketCount = () => {
    if (getPortalVariable('hasUserSession')) {
      actions.getBasketCount(platformBaseUrl)(dispatch);
    }
  };

  const getMenu = platformId => {
    if (!state.hasProductsBeenFetched) {
      actions.getMenu(platformId)(dispatch);
    }
  };

  const getPromos = (platformId, isB2B, userId, isNewUser) => {
    const { browserAPI } = baseUrls;
    if (!state.hasPromosBeenFetched && browserAPI && platformId) {
      actions.getPromos(
        browserAPI,
        platformId,
        isB2B,
        userId,
        isNewUser,
      )(dispatch);
    }
  };

  const loadInitialState = () => actions.loadInitialState();

  return (
    <HeaderContext.Provider
      value={{
        ...state,
        loadInitialState,
        getBasketCount,
        getMenu,
        getPromos,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

HeaderProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: InitialStatePropType.isRequired,
};

export default HeaderContext;
